/**
 * Logikk for Psykologisk Trygghet (PSI)
 * Basert på Edmondsons 6 faktorer.
 */

export const PS_DIMENSIONS = [
  { id: 'trust', name: 'Tillit i teamet', icon: 'Shield', desc: 'Troen på at kolleger har gode intensjoner.' },
  { id: 'speaking_up', name: 'Ytringsklima', icon: 'MessageSquare', desc: 'Trygghet ved å dele ideer og bekymringer.' },
  { id: 'mistake_tolerance', name: 'Feiltoleranse', icon: 'RefreshCw', desc: 'Hvordan teamet håndterer feil og uhell.' },
  { id: 'leadership', name: 'Støttende ledelse', icon: 'UserCheck', desc: 'Lederens evne til å skape trygghet.' },
  { id: 'respect', name: 'Respektfull dialog', icon: 'Heart', desc: 'Verdsetting av ulike perspektiver.' },
  { id: 'learning', name: 'Teamlæring', icon: 'BookOpen', desc: 'Kollektiv læring fra erfaringer.' }
];

export const getPSICategory = (score) => {
  if (score >= 85) return { label: 'Eksponentielt trygg', color: 'emerald', status: 'Exceptional' };
  if (score >= 70) return { label: 'Høy trygghet', color: 'indigo', status: 'High' };
  if (score >= 50) return { label: 'Moderat trygghet', color: 'amber', status: 'Moderate' };
  return { label: 'Lav trygghet', color: 'rose', status: 'Low' };
};

export const teamComparisonData = [
  { id: 't1', name: 'Produkt-team', psi: 88, scores: { trust: 92, speaking_up: 85, mistake_tolerance: 80, leadership: 95, respect: 90, learning: 86 } },
  { id: 't2', name: 'Marked og Salg', psi: 62, scores: { trust: 65, speaking_up: 50, mistake_tolerance: 45, leadership: 70, respect: 75, learning: 68 } },
  { id: 't3', name: 'Kundeservice', psi: 74, scores: { trust: 70, speaking_up: 78, mistake_tolerance: 65, leadership: 82, respect: 80, learning: 70 } },
  { id: 't4', name: 'Ledelsen', psi: 45, scores: { trust: 40, speaking_up: 35, mistake_tolerance: 30, leadership: 55, respect: 60, learning: 50 } }
];

export const getAIRecommendations = (team) => {
  const recommendations = [];
  const workshops = [];

  if (team.scores.speaking_up < 60) {
    recommendations.push("Innføre 'Silent Brainstorming' for å sikre at alle stemmer blir hørt.");
    workshops.push("Workshop: Kunsten å ytring – fra taushet til trygghet.");
  }
  if (team.scores.mistake_tolerance < 50) {
    recommendations.push("Etablere 'Blameless Post-mortems' etter prosjektfeil.");
    workshops.push("Sesjon: Feiling som læringsverktøy.");
  }
  if (team.scores.trust < 60) {
    recommendations.push("Gjennomføre 'Personal Maps' for å bygge relasjonell forståelse.");
    workshops.push("Team-building: Psykologisk kontrakt og sårbarhet.");
  }

  return {
    tips: recommendations.length > 0 ? recommendations : ["Oppretthold dagens gode kultur gjennom regelmessige 1-til-1 samtaler."],
    workshops: workshops.length > 0 ? workshops : ["Inspirasjonsforedrag om psykologisk trygghet."]
  };
};